// JsFromRoutes CacheKey 09cad28358e6739d77063901110c8e1c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  handleFolderDeletion: definePathHelper('post', '/legacy_folders/handle_folder_deletion.html'),
}
